import React, { forwardRef } from 'react';
import InputMask from 'react-input-mask';
import '../css/financeiro-parcela-pagar.css';

const CustomInput = forwardRef(({ inputName = null, onChange = null, placeholder = "", title = "", value = "", id = null, onClick = null, label, readOnly = false, disabled = null, className = "", required = false, autoComplete = undefined }, ref) => (
    <div className="fin-pp__field">
        <label className="fin-pp__label" htmlFor="floatingInput">{label}</label>
        <InputMask
            disabled={disabled}
            ref={ref}
            title={title}
            mask="99/99/9999"
            readOnly={readOnly}
            type="text"
            className={`fin-pp__input ${className}`}
            name={inputName}
            onChange={onChange}
            value={value}
            id={id}
            onClick={onClick}
            required={required}
            autoComplete={autoComplete}
        />
    </div>
));

export default CustomInput;
